import { getAllCycles, getOpenCycles, getExams } from '@/api/cycle'
export default {
    state: {
        cycles: [],
        openCycles: [],
        exams: []

    },

    mutations: {

        SET_CYCLES: (state, data) => {
            state.cycles = [...data]
        },
        SET_OPEN_CYCLES: (state, data) => {
            state.openCycles = [...data]
        },
        SET_EXAMS: (state, data) => {
            state.exams = [...data]
        },

    },

    actions: {
        getAllCycles({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getAllCycles().then(response => {
                    if (!response.data) {
                        reject('error')
                    }
                    var data = response.data


                    commit('SET_CYCLES', data)
                    commit('SET_TABLE_TEXT', false)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getOpenCycles({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getOpenCycles().then(response => {
                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data
                    for (var i = 0; i < data.length; i++) {
                        for (var j = 0; j < data[i].Classes.length; j++) {
                            data[i].Classes[j].Description = ""
                            data[i].Classes[j].State = false
                        }
                    }

                    commit('SET_TABLE_TEXT', false)
                    commit('SET_OPEN_CYCLES', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getExams({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {

                getExams().then(response => {
                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data

                    commit('SET_TABLE_TEXT', false)
                    commit('SET_EXAMS', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },


    }
}